import {getAvailableAgents} from './novaInvocationStore';

/**
 * The agent a bare Action click runs.
 *
 * `isDefault` is read first because that is the field an account default will arrive on, but
 * nothing sets it today - the back end always sends false. Until something does, the first agent
 * in the resolved list is what a bare Action uses, which is the same answer the picker's own
 * "used if you click Action without choosing an agent" marker gives.
 */
export function defaultAgentId(): string | null {
	const agents = getAvailableAgents();
	return agents.find(agent => agent.isDefault)?.id ?? agents[0]?.id ?? null;
}

/**
 * The agent's name, but only when naming it tells the reader something.
 *
 * A specialist is chosen for one run and is not remembered, so a control whose run used one has to
 * say which - the label alone says "Working" or "Continue" and cannot. The default agent is the
 * opposite case: the entry banner and the in-task card already explain it, so repeating its name on
 * every row would be noise on a list of twenty tasks.
 *
 * Null therefore means "say nothing", and covers three cases that all want that: the run used the
 * default agent, the run named no agent at all, and the agent is no longer in the viewer's list -
 * where the raw id is all that is left, and an id is not a name a tooltip should offer.
 */
export function specialistTitleFor(agentId: string | null | undefined): string | null {
	if (!agentId) return null;
	if (agentId === defaultAgentId()) return null;
	return getAvailableAgents().find(agent => agent.id === agentId)?.title ?? null;
}
